import AuthApi from "@/services/auth-api";

class FirebaseAuthBackend {
    constructor() {
        
    }

    /**
     * Login user with given details
     */
    loginUser = (email, password, keepSessionOpen) => {
        return new Promise((resolve, reject) => {
            AuthApi.signIn(email, password, keepSessionOpen)
            .then(response => {
                //adding cookies

                var currentDomain = window.location.hostname;
                var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;

                const expiryDays = 365;
                var expiryDate = new Date(Date.now() + expiryDays * 1000 * 60 * 60 * 24);

                //document.cookie = 'tok' + "=" + response.token + ";" + "10000" + ";path=/;"                   +    'domain='  + cookieDomain + ';'      ; 
                //document.cookie = 'rtok' + "=" + response.refreshToken + ";" + "10000" + ";path=/;"           +    'domain='  + cookieDomain + ';'      ; 

                document.cookie = 'tok' + "=" + response.token + "; " +
                     (keepSessionOpen ? ("expires=" + expiryDate.toUTCString() + "; ") : "") +
                     "path=/; " +
                     "domain=" + cookieDomain + "; ";

                document.cookie = 'rtok' + "=" + response.refreshToken + "; " +
                     (keepSessionOpen ? ("expires=" + expiryDate.toUTCString() + "; ") : "") +
                     "path=/; " +
                     "domain=" + cookieDomain + "; ";

                resolve(response.token);

            }, (error) => {
                reject(this._handleError(error));
            });
        });
    }


    loginUserWithOauth = (oauthCode, oauthProvider) => {
        return new Promise((resolve, reject) => {
            AuthApi.signInValidationWithOAuth2(oauthProvider, oauthCode)
            .then(response => {
                //adding cookies

                var currentDomain = window.location.hostname;
                var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;


                //document.cookie = 'tok' + "=" + response.token + ";" + "10000" + ";path=/;"                   +    'domain='  + cookieDomain + ';'      ; 
                //document.cookie = 'rtok' + "=" + response.refreshToken + ";" + "10000" + ";path=/;"           +    'domain='  + cookieDomain + ';'      ; 

                document.cookie = 'tok' + "=" + response.token + "; " +
                     "path=/; " +
                     "domain=" + cookieDomain + "; ";

                document.cookie = 'rtok' + "=" + response.refreshToken + "; " +
                     "path=/; " +
                     "domain=" + cookieDomain + "; ";

                resolve(response);

            }, (error) => {
                reject(this._handleError(error));
            });
        });
    }

    signInWithOauth2Validate = (oauthProvider, oAuth2AccessToken, username) => {
        return new Promise((resolve, reject) => {
            AuthApi.signInWithOauth2Validate(oauthProvider, oAuth2AccessToken, username)
            .then(response => {
                //adding cookies

                var currentDomain = window.location.hostname;
                var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;


                //document.cookie = 'tok' + "=" + response.token + ";" + "10000" + ";path=/;"                   +    'domain='  + cookieDomain + ';'      ; 
                //document.cookie = 'rtok' + "=" + response.refreshToken + ";" + "10000" + ";path=/;"           +    'domain='  + cookieDomain + ';'      ; 

                document.cookie = 'tok' + "=" + response.token + "; " +
                     "path=/; " +
                     "domain=" + cookieDomain + "; ";

                document.cookie = 'rtok' + "=" + response.refreshToken + "; " +
                     "path=/; " +
                     "domain=" + cookieDomain + "; ";

                resolve(response);

            }, (error) => {
                reject(this._handleError(error));
            });
        });
    }


    /**
     * Logout the user
     */
    logout = () => {
        return new Promise((resolve, reject) => {
            AuthApi.logout()
            .then(() => {

                var currentDomain = window.location.hostname;
                var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;

                //delete cookies

                document.cookie = 'tok' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
                document.cookie = 'rtok' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
               

                resolve(true);
            }, (error) => {
                reject(this._handleError(error));
            });
        });

        /*return new Promise((resolve, reject) => {
            AuthApi.
            firebase.auth().signOut().then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })

        });*/
    }

    /**
     * Returns the authenticated user
     */
    getAuthenticatedUser = () => {
        const token = ('; '+document.cookie).split(`; tok=`).pop().split(';')[0];
        return !token ? null : token
    }

    /**
     * Handle the error
     * @param {*} error 
     */
    _handleError(error) {
        //TODO to be fixed later
        // var errorMessage = error.message;
        // return errorMessage;
        console.log(error)
        return  ("Login ou mot de passe erroné")
    }
}


let _fireBaseBackend = null;

const initFirebaseBackend = () => {
    if (!_fireBaseBackend) {
        _fireBaseBackend = new FirebaseAuthBackend();
    }
    return _fireBaseBackend;
}

const getFirebaseBackend = () => {
    return _fireBaseBackend;
}

const refreshToken = (store) => {
    if (store.state.auth.isRefreshing) {
        return store.state.auth.refreshingCall;
    }

    //refresh token from cookie
    const refreshTokenFromCookie = ('; '+document.cookie).split(`; rtok=`).pop().split(';')[0];
    // store.commit('auth/setRefreshingState', true);
    const refreshingCall = AuthApi.refresh(refreshTokenFromCookie).then((response) => {
        


        var currentDomain = window.location.hostname;
        var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;

        const keepSessionOpen = response.keepSession ? response.keepSession : false;
        const expiryDays = 365;
        var expiryDate = new Date(Date.now() + expiryDays * 1000 * 60 * 60 * 24);

        //adding cookies
        //document.cookie = 'tok' + "=" + response.token + ";" + "10000" + ";path=/;"                   +    'domain='  + cookieDomain + ';'      ; 
        //document.cookie = 'rtok' + "=" + response.refreshToken + ";" + "10000" + ";path=/;"           +    'domain='  + cookieDomain + ';'      ; 

        document.cookie = 'tok' + "=" + response.token + "; " +
                    (keepSessionOpen ? ("expires=" + expiryDate.toUTCString() + "; ") : "") +
                     "path=/; " +
                     "domain=" + cookieDomain + "; ";

        document.cookie = 'rtok' + "=" + response.refreshToken + "; " +
                    (keepSessionOpen ? ("expires=" + expiryDate.toUTCString() + "; ") : "") +
                     "path=/; " +
                     "domain=" + cookieDomain + "; ";


 
        // store.commit('auth/setToken', response.token)
        // store.commit('auth/setRefreshingState', false);
        // store.commit('auth/setRefreshingCall', undefined);
        return Promise.resolve(true);
    // }, (error) => {
    //     return Promise.reject(false);
        }, () => {
        return Promise.reject(false);
                
            }
    
    
    
    );
    // store.commit('auth/setRefreshingCall', refreshingCall);
    return refreshingCall;
}


export { initFirebaseBackend, getFirebaseBackend, refreshToken };
